// Local ordering only. No server fields, counters or notification rules change.
// WeakMap metadata is not serialized and does not enter the public API payload.
let sequence = 0;
const snapshots = new WeakMap();

export const beginSessionSnapshot = () => ++sequence;

export const tagSessionSnapshot = (sessions, startedAt) => {
    const rows = Array.isArray(sessions) ? sessions : [];
    snapshots.set(rows, startedAt);
    return rows;
};

export const createSessionSnapshotState = () => ({ resetAt: 0, appliedAt: 0, changes: new Map() });

export const invalidateSessionSnapshots = state => {
    state.resetAt = ++sequence;
    state.appliedAt = 0;
    state.changes.clear();
};

export const recordSessionChange = (state, id, patch = null) => {
    if (id === undefined || id === null) return;
    state.changes.set(String(id), { at: ++sequence, patch });
};

export const mergeSessionSnapshot = (state, current, sessions) => {
    const rows = Array.isArray(sessions) ? sessions : [];
    const startedAt = snapshots.get(rows);
    if (startedAt === undefined) {
        // Preserve existing explicit setSessions calls, but invalidate older HTTP.
        invalidateSessionSnapshots(state);
        return rows;
    }
    if (startedAt < state.resetAt || startedAt < state.appliedAt) return null;

    const incoming = new Map(rows.map(row => [String(row.id), row]));
    const keptIds = new Set();
    const changedRows = current.filter(row => {
        const key = String(row.id);
        if ((state.changes.get(key)?.at || 0) <= startedAt) return false;
        keptIds.add(key);
        return true;
    }).map(row => ({ ...incoming.get(String(row.id)), ...row }));
    const remainingRows = rows.filter(row => !keptIds.has(String(row.id))).map(row => {
        const change = state.changes.get(String(row.id));
        // A read event can precede the first snapshot containing this chat.
        return change?.at > startedAt && change.patch ? { ...row, ...change.patch } : row;
    });

    state.appliedAt = startedAt;
    for (const [id, change] of state.changes) {
        if (change.at <= startedAt) state.changes.delete(id);
    }
    // Preserve the existing live ordering, and never use max(unreadCount): reads
    // must be able to reduce the count to zero, not just increment it.
    return [...changedRows, ...remainingRows];
};
